import { render } from "./MyProfile.vue?vue&type=template&id=76671d66&scoped=true"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"

import "@/assets/css/MyProfile.scss?vue&type=style&index=0&id=76671d66&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76671d66"]])

export default __exports__